export default [{
    path: '/resources',
    name: 'ResourcesHome',
    component: () => import('@/modules/main/resources/views/ResourcesHome.vue'),
    children: []
}];
